module.exports = __webpack_public_path__ + "static/media/uph_0004.5d069ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/uph_0004.jpg
// module id = 635
// module chunks = 0